import { render, staticRenderFns } from "./TestCode.vue?vue&type=template&id=4e9bd1fe&scoped=true&"
import script from "./TestCode.vue?vue&type=script&lang=js&"
export * from "./TestCode.vue?vue&type=script&lang=js&"
import style0 from "./TestCode.vue?vue&type=style&index=0&id=4e9bd1fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9bd1fe",
  null
  
)

export default component.exports